<template>
  <div class="list">
    <cc-header-nav title="商城快讯"></cc-header-nav>
    <div class="wrapper">
      <van-list
        v-model="m_loading"
        :finished="m_finished"
        :finished-text="m_finishedText"
        @load="mHandlePullUpLoadMore"
        :immediate-check="m_immediateCheck"
      >
        <div class="cell-list">
          <cc-animation-list :interval="50">
            <div class="cell-box ell" v-for="item in newList" :key="item.id">
              <router-link
                :to="{
                  path: `/news/${item.id}`
                }"
                class="inline100"
                >{{ item.title }}</router-link
              >
            </div>
          </cc-animation-list>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Loading, List, PullRefresh } from 'vant'
import { mapActions, mapGetters } from 'vuex'
import ListMixin from '../../../mixins/list.js'
Vue.use(Loading)
  .use(List)
  .use(PullRefresh)
export default {
  name: 'news-list',
  mixins: [ListMixin],
  data () {
    return {
      newList: [],
      isLoading: false,
      loadmore: false,
      finished: false
    }
  },
  computed: {
    ...mapGetters(['getLoadNewsList'])
  },
  created () {
    this.m_page.limit = 20
    this.loadData()
  },
  mounted () {},
  methods: {
    ...mapActions(['LOAD_NEWS_LIST']),
    /*
     * 加载公共列表
     */
    async loadData (reset) {
      this.mRequest()
      await this.LOAD_NEWS_LIST({
        page: this.m_page.curr,
        limit: this.m_page.limit
      })
      this.loadmore = false
      if (this.getLoadNewsList.code === 1) {
        if (this.getLoadNewsList.data.news_list.length === 0) {
          this.mEnd()
        }
        if (reset) {
          this.mReset()
          this.newList = this.getLoadNewsList.data.news_list
        } else {
          this.newList = [
            ...this.newList,
            ...this.getLoadNewsList.data.news_list
          ]
        }
      }
      this.mSuccess()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/var.scss";

.wrapper {
  height: calc(100% - 45px);
  overflow-y: auto;
}
.cell-list {
  background-color: $bgColor;
}
.cell-box {
  box-sizing: border-box;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  margin-bottom: 2px;
  background-color: #fff;
  font-size: 14px;
  color: #333;
  display: flex;
  justify-content: space-around;
}
.inline100 {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.page-end {
  line-height: 30px;
}
.van-loading {
  left: 50%;
  transform: translate3d(-50%, 0, 0);
}
</style>
